import { courseConstants } from '../constants';

export function courses(state = {}, action) {
  switch (action.type) {

    case courseConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case courseConstants.GETALL_SUCCESS:
      return {
        items: action.courses
      };
    case courseConstants.GETALL_FAILURE:
      return {
        error: action.error
      };

    case courseConstants.DELETE_REQUEST:
      // add 'deleting:true' property to course being deleted
      return {
        ...state,
        items: state.items.map(course =>
          course.id === action.id
            ? { ...course, deleting: true }
            : course
        )
      };
    case courseConstants.DELETE_SUCCESS:
      // remove deleted course from state
      return {
        items: state.items.filter(course => course.id !== action.id)
      };
    case courseConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to course
      return {
        ...state,
        items: state.items.map(course => {
          if (course.id === action.id) {
            // make copy of course without 'deleting:true' property
            const { deleting, ...courseCopy } = course;
            // return copy of course with 'deleteError:[error]' property
            return { ...courseCopy, deleteError: action.error };
          }

          return course;
        })
      };

    default:
      return state
  }
}
